var $ = jQuery;
const focusableSelector = [
  "a[href]:not([tabindex='-1'])",
  "area[href]:not([tabindex='-1'])",
  "input:not([disabled]):not([tabindex='-1'])",
  "select:not([disabled]):not([tabindex='-1'])",
  "textarea:not([disabled]):not([tabindex='-1'])",
  "button:not([disabled]):not([tabindex='-1'])",
  "iframe:not([tabindex='-1'])",
  "[tabindex]:not([tabindex='-1'])",
  "[contentEditable=true]:not([tabindex='-1'])",
].join(",");

const days = {
  'sun': 'sunday',
  'mon': 'monday',
  'tue': 'tuesday',
  'wed': 'wednesday',
  'thu': 'thursday',
  'fri': 'friday',
  'sat': 'saturday'
}

$( document ).ready(function() {
  $('.swiper-button-prev svg, .swiper-button-next svg').attr('aria-hidden','true');
  $('html').attr('data-page-url', window.location.pathname);
  
  $("body").append(
    '<div class="sr-only live-status-region" role="status"></div>'
  );

  $('meta[name="viewport"]').attr({
    content: "width=device-width, initial-scale=1",
  });

  $('.a11y_label').each(function(){
    var headingtext = $(this).find("h3").text().trim();
    var linktext = $(this).find("div a").text().trim();
    $(this).find("div a").attr("aria-label", linktext+' '+headingtext).removeAttr('title');
  });

  $('.mobile_nav.dropdown_link').each((i, button) => {
    $(button).attr({
      'role': 'button',
      'tabindex': 0,
    });

    function handleChange() {
      const isMobile = window.matchMedia("(max-width: 767px)");
      const parent = $(button).closest('[data-mobile-menu]');

      parent.attr({
        'aria-expanded': parent.get(0).hasAttribute('open')
      })
    }

    $(button).on('focus', () => {
      handleChange();
    });
    
    $(button).on('click', (e) => {
      setTimeout(() => {
        handleChange();
      }, 250);
    });

    handleChange();
  });
  

  $('.paginate').each((i, paginate) => {
    $(paginate).find('span').each(function(i, el){
      var text = $(this).find('> a').text().trim();
      
      $(this).find('> a').attr('aria-label','page'+' '+text);
    });
    
    const current = $('.paginate span.page.current');
    const currentClone = current.clone();

    current.text('');
    
    current.append(`<span aria-hidden="true">${currentClone.text()}</span>`);
    current.append(`<span class="sr-only">current page ${currentClone.text()}</span>`);
  });

  $('div.paginate').attr('role','list');
  $('div.paginate > span').attr('role','listitem');
  $('.paginate > span.deco').attr({'aria-hidden':'true'});
  
  $('.shogun-accordion-header .shogun-accordion-icon.shogun-icon-chevron').attr('aria-hidden','true');



  $('.footer .footer_menu, .footer .footer_content').each((i, menu) => {
    const isMobile = window.matchMedia("(max-width: 767px)");
    const heading = $(menu).find('h6');


    if (isMobile.matches) {
        const icon = $(heading).find('.right');
        
        icon.removeAttr('tabindex').removeAttr('role').removeAttr('aria-label');
        icon.attr({
          'aria-hidden': true
        })
    
        heading.attr({
          'tabindex': 0,
          'role': 'button',
        })
    
        heading.removeAttr('aria-level');
    
        heading.on('keydown', (e) => {
          if(e.key === 'Enter') {
            e.preventDefault();
            $(e.target).click()
          }
        })
    
    
        $(menu).children('h6').each((i, el) => {
          function handleChange() {
            heading.attr('aria-expanded', el.classList.contains('active'));
          }
          
          const observer = new MutationObserver((mutations) => {
            handleChange();
          });
    
          handleChange();
          
          observer.observe(el, {
            attributes: true,
            attributeFilter: ['class']
          })
        });
    } else {
      heading.attr({
        'role': 'heading',
        'aria-level': 2
      })
    }
  });



  $('.shogun-accordion').each((i, accordion) => {
    $(accordion).find('.shogun-accordion-icon.shogun-icon-plus').attr('aria-hidden','true');
    
    const header = $(accordion).find(".shogun-accordion-header");
    
    header.attr({
      'role':'button',
      'tabindex':'0',
      'aria-expanded': $(accordion).hasClass('shogun-accordion-active')
    });
    
    header.on('click', () => {
      setTimeout(() => {
        header.attr("aria-expanded", $(accordion).hasClass('shogun-accordion-active'));
      }, 250);
    });
    
    header.keydown(function (event) {
     if(event.which == "13"){
       $(this).click();
     }
    });

    if(document.querySelector('html[data-page-url$="/products/penrose-wireless-planar-magnetic-headset"]')) {
      $(accordion).find('.shogun-accordion-title').attr({
        'role': 'heading',
        'aria-level': 3
      });
    }

    if(document.querySelector('html[data-page-url$="/pages/user-guides-and-driver-downloads"]')) {
      $(accordion).find('.shogun-accordion-title').attr({
        'role': 'heading',
        'aria-level': 2
      });
    }
    if(document.querySelector('html[data-page-url$="/collections/legacy-products/products/mobius"]')) {
      $(accordion).find('.shogun-accordion-title').attr({
        'role': 'heading',
        'aria-level': 2
      });
    }
  });
  
  $('a[href="/pages/audeze-support"]').attr('aria-label','F A Qs');
  // $('form > .errors').attr('role','alert');

  $('#recover-password > h4').attr({'role':'heading','aria-level':'2'});
  $('.cc-window.cc-center-blocked-content').removeAttr("tabindex");
  $('.product_gallery.js-product-gallery').removeAttr("tabindex");
  $('.gallery-cell.is-selected a.lightbox').attr('role','button');
  
  
 
  $('#banner-video').attr('title','Audeze Filter banner Video');

  $('input[name="customer[first_name]"]').attr('autocomplete','given-name');
  $('input[name="customer[last_name]"]').attr('autocomplete','family-name');
  $('input[name="customer[password]"]').attr('autocomplete','new-password');

  $('img[src*="files/1/3013/1908/files/MainBanner"], img[src*="56dffd59-d8a7-4f3d-8967-933ca16b4fe7"]').attr({
    'alt': 'Maxwell Wireless Gaming Headset, PC Gaming, XBOX, PlayStation'
  });

  $('img[src*="files/1/3013/1908/t/2/assets/MM-500-logo.svg"]').attr({
    'alt': 'MM Series MM 500 Purpose-Built Tools for the Studio and Beyond'
  });

  $('img[src*="files/1/3013/1908/t/2/assets/LCD-5-logo.svg"]').attr({
    'alt': 'LCD-5 Transparency Resolution And Speed @Only 420g'
  });

  $('img[src*="files/1/3013/1908/t/2/assets/CRBN-homepage-logo.png"]').attr({
    'alt': 'CRBN Electrostatic Headphone'
  });

  $('img[src*="files/1/3013/1908/t/2/assets/FILTER-homepage-logo.png"]').attr({
    'alt': 'Audeze filter, connect everywhere, anywhere with no background noise!'
  });

  $('img[data-src*="6ac946d6-0263-413c-933e-a8e42ddaffb0"]').attr({
    'alt': '80+ hours maxwell battery life, 40~ hours premium gaming headset, 25~ hours high-end gaming headset, 10~ hours standard gaming headset'
  });

  $('img[src*="b6b0fcca-8e50-42c0-b181-b7845b540cba"]').attr({
    'alt': 'Xbox, Windows'
  });

  $('img[src*="a12ea2e2-ab28-4de2-a14d-fb26a6e4a76a"]').attr({
    'alt': "LCD-X The Audio Proffesional's Choice"
  });

  $('img[src*="a32758eb-2b44-40d4-bdf8-bb6f8f9ce6ce"]').attr({
    'alt': "IGN"
  });

  $('img[src*="d3b214bb-e546-44fa-b910-075ffabdb27b"]').attr({
    'alt': 'Audeze Euclid: Inside the Technology'
  });

  $('img[src*="dc39224a-f092-4994-8485-71c5bc82d047"]').attr({
    'alt': 'Euclid Fit Guide'
  });

  $('img[src*="ADZ_Tech_000x_360a6887-81fe-4d8d-b794-0266531ad75a"]').attr({
    'alt': ''
  });

  $('p[style*="line-height: 8px"]').each((i, p) => {
    p.style.lineHeight = 'normal'
  })

  $('.js-featured-promotions figure.feature-section').each((i, section) => {
    $(section).find('.title.title-below').parent().attr({
      'tabindex': -1,
      'role': 'none',
      'aria-hidden': true
    });

    const title = $(section).find('.title:not(.title-below)');
    const anchor = $(section).find('a.link-promo');

    anchor.attr({
      'aria-label': title.text().trim()
    })
  });

  $('.top-bar--right-menu').each((i, container) => {
    const menu = $(container).find('.top-bar__menu');
    const cart = $(container).find('.cart-container');
    const transcy = $(container).find('.transcy-switcher-manual');
    
    menu.attr({
      'role': 'list'
    });
    
    menu.find('> li').attr({
      'role': 'listitem'
    });

    cart.attr({
      'role': 'listitem'
    });
    
    cart.appendTo(menu);

    const observer = new MutationObserver((mutations) => {
      const switcher = $(container).find('#transcyBtnSwitcher');

      if(switcher.attr('tabindex')) {
        return;
      }
      
      switcher.attr({
        'tabindex': 0,
        'role': 'button'
      });

      function handleChange() {
        switcher.attr('aria-expanded', switcher.siblings('.transcy-switcher').hasClass('transcy-show'))
      }

      switcher.on('click', (e) => {
        handleChange();
      });

      handleChange();
     
    });
    if (transcy.length) {
    observer.observe(transcy.get(0), {
      childList: true,
      subtree: true
    });
  }
 
  });

  $('.search-container').each((i, container) => {
    const input = container.querySelector('input[name="q"]');

    if(!input) {
      return
    }

    const announceSearchResults = debounce(() => {
      if(input.value.length < 1) {
        return
      }
      
      const noResult = $(container).find('.no-results');

      if(noResult.length > 0) {
        announceToScreenReader(noResult.text().trim());
        return
      };
      
      const resultItems = $(container).find(".search__results .item-result");
      announceToScreenReader(`${resultItems.length} results found`);
      
    }, 1000);

    input.addEventListener("input", (e) => {
        announceSearchResults();
    });
    
  });


  $('.section-wrapper main').attr({
    'role': 'none'
  });

  $('.spr-summary-starrating').each((i, starring) => {
    const anchor = $(starring).children('a');

    if(anchor.length < 1) {
      return;
    }

    anchor.on('click', (e) => {
      $('.spr-summary-actions-newreview').focus();
    });
    
  });


  
  
  
  $('.product__details').each(function(){
    var infotext = $(this).find('.price-ui-badges .price-ui-badge__sticker').text().trim(); 
    var imgtext = $(this).find('.relative.product_image > a img').attr('alt');
    $(this).find('.relative.product_image > a img').attr('alt',infotext +' '+imgtext);
  });

  $('a[href="https://audeze.zendesk.com/hc/en-us/articles/360054366872-How-to-Load-and-Save-Penrose-EQ-Presets-using-the-HQ-app"]').attr('aria-label','Click here for Instructions on Loading and Saving Presets can be found');
  $('.cart__remove-btn').attr('role','button');
  $('.cart_items .mini-cart__item').each(function(){
    var product_title = $(this).find('.mini-cart__item-title').text().replace(/\s+/g, ' ').replace(/&nbsp;/g, " ").trim();
    $(this).find('.product-quantity-box .quantity').attr('aria-label','Quantity of'+' '+ product_title);
    $(this).find('.product-quantity-box .product-minus').attr('aria-label','Decrease quantity of'+' '+ product_title);
    $(this).find('.product-quantity-box .product-plus').attr('aria-label','Increase quantity of'+' '+ product_title);
    $(this).find('.cart__remove-btn').attr('aria-label','Remove'+' '+ product_title);
  });

  $('.cart__item--content').each(function(){
    var product_title = $(this).find('.cart__item--title').text().replace(/(\r\n|\n|\r)/gm, "").trim();
    $(this).find('.product-quantity-box .quantity').attr('aria-label','Quantity of'+' '+ product_title);
    $(this).find('.product-quantity-box .product-minus').attr('aria-label','Decrease quantity of'+' '+ product_title);
    $(this).find('.product-quantity-box .product-plus').attr('aria-label','Increase quantity of'+' '+ product_title);
  });

  $('.a11y_breadcrumb ul li:last-child > a').attr('aria-current','page');

  // $('#product-registration  table th').attr('scope','col');

  
  $('#mpr-product-inputs .form-group').each(function(){
   var label = $(this).find('label').attr('for'); 
   $(this).find('input').attr('id', label);
  });

  $('#mpr-product-inputs .form-group input[type="text"]').attr('aria-required','true');

  $('.a11y_custom_heading .one-third h3').attr({'role':'heading','aria-level':'2'});
  
  $('.vf-form-pristine .form-group').each(function(i, group){
    const inputs = $(group).find('input:not([type="button"])');

    inputs.each((i, input) => {
      const name = $(input).attr('name');
      const id = $(input).attr('id');
      const newId = randomId();
      
      if (!name) {
        return
      }
  
      let label = $(group).find(`label[for="${name}"], label[for="${id}"]`);
  
      if(label.length < 1) {
        label = $(`<label for="${id}">${$(input).attr('placeholder')}</label>`);
        $(group).prepend(label);
      }
  
      $(input).attr({
        'id': newId
      });
  
      label.attr({
        'for': newId
      });

      $(input).on('focus', () => {
        $(input).attr({
          'id': newId
        });
      });
    });

    const purchaseDate = $(group).find('input[name="purchaseDate"]');

    purchaseDate.on('click', (e) => {
  
      setTimeout(() => {
        const calendars = $(group).find('.calendar');

        calendars.each((i, calendar) => {
          const cells = $(calendar).find('span.cell:not(.blank)');
          const buttons = $(calendar).find('span.prev, span.up, span.next');

          cells.add(buttons).each((i, triggerable) => {
            triggerable.addEventListener('keydown', (e) => {
              if(e.key === "Enter") {
                triggerable.click();
              }
            })
          })
        });
  
        calendars.each((i, calendar) => {
          if(calendar.style.display === 'none') {
            return
          }

          const buttons = $(calendar).find('span.prev, span.up, span.next');
          const cells = $(calendar).find('span.cell:not(.blank)');

          function handleChange() {
            cells.each((i, cell) => {
              if(!cell.classList.contains('day-header')) {
                cell.setAttribute('role', 'button');
                cell.setAttribute('tabindex', 0); 
              }
              
              if(cell.classList.contains('selected')) {
                cell.setAttribute('aria-label', `selected ${cell.textContent}`);
              } else {
                cell.removeAttribute('aria-label');
              }
              
              if(cell.classList.contains('day-header')) {
                if(days.hasOwnProperty(cell.textContent.toLowerCase())) {
                  const existingText = $(cell).text();
                  $(cell).text('');
                  $(cell).append(`<span aria-hidden="true">${existingText}</span>`);
                  $(cell).append(`<p class="sr-only">${days[cell.textContent.toLowerCase()]}</p>`);
                }
              }
            });
          }

          function handleClick(e) {
            const label = calendar.querySelector('span.up');
            announceToScreenReader(`you are on ${label.textContent} slide`, `status`, 100);
            trapFocus(calendar);
            e.target.focus();
            handleChange();
          }

          handleChange();

          buttons.each((i, button) => {
            button.setAttribute('role', 'button');
            button.setAttribute('tabindex', 0);
            button.addEventListener('click', handleClick);
          });

          $(calendar).find('.prev').attr({
            'aria-label': 'Previous'
          });
          
          $(calendar).find('.next').attr({
            'aria-label': 'Next'
          });

          const observer = new MutationObserver((mutations) => {
            queueMicrotask(() => {
              if(calendar.style.display === 'none') {
                buttons.each((i, button) => {
                  button.removeEventListener('click', handleClick);
                });
              }
            });
          });

          observer.observe(calendar, {
            attributes: true,
            attributeFilter: ['style']
          });

          trapFocus(calendar);

          $(window).on('keydown', (e) => {
            if(e.code === 'Escape') {
              $(calendar).hide();
              purchaseDate.focus();
            }
          })
        })
      }, 50)
    })

    purchaseDate.on('keydown', (e) => {
      if(e.key === 'Enter') {
        e.preventDefault();
        purchaseDate.trigger('click');
      }
    })
  });

  $('.customer-form-wrapper').each((i, form) => {
    const inputs = $(form).find('input');

    inputs.each((i, input) => {
      const id = randomId();
      const feedback = $(input).siblings('.form-control-feedback');
      const label = $(`label[for="${$(input).attr('id')}"]`);

      if(input.hasAttribute('required')) {
        label.append(`<span>*</span>`);
      }
      
      const observer = new MutationObserver(() => {
        if(input.classList.contains('form-control-danger-required')) {
          input.setAttribute('aria-describedby', id);
          feedback.attr({
            'id': id
          })
        }
      });

      observer.observe(input, {
        attributes: true,
        attributeFilter: ['class']
      })
    })
  });
  
  $('#mpr-customer-form .vf-field-invalid-required').each(function(i,e){
    $(this).find('input').attr('aria-describedby', i);
    var id = $(this).find('.form-control-feedback').attr('id',i);
  });

  $('#mpr-product-inputs .form-group.error').attr('role','alert');

   $('.vf-field-pristine').each((i, container) => {
    const input = container.querySelector('input.Typeahead__input');

    if(!input) {
      return
    }

    const announceSearchResults = debounce(() => {
      if(input.value.length < 1) {
        return
      }
            
      const resultItems = $(container).find(".mpr-search-result > li");
      announceToScreenReader(`${resultItems.length} results found`);
    }, 2000);

    input.addEventListener("input", (e) => {
      announceSearchResults();
      const wrap = $(input).closest('.Typeahead');
      const close = $('#mpr-app-content .select-product input').siblings('i').last();
      close.appendTo(wrap);
    });

     const observer = new MutationObserver((mutations) => {
       console.log(mutations);
     });

     observer.observe(container, {
       childList: true,
       subtree: true
     })
  });

  $('.vf-form-pristine .select-product label > div').append(`<span class="required-star"> *</span>`);
  
  $('#mpr-app-content .select-product input').keydown(function (event) {
    setTimeout(function () {
      var close = $('#mpr-app-content .select-product input').siblings('i').last();
      close.attr({'role':'button','tabindex':'0','aria-label':'Clear'});
      close.keydown(function (event) {
        if(event.which == "13")
          $(this).click();
      });
    }, 1000);
  });   


  $('.product-gallery__thumbnails .gallery-cell').attr('role','button');
  const slides = $('.product_gallery_nav').find('.gallery-cell');
       
  slides.each((i, slide) => {
    function handleClick(e) {
      e.preventDefault();
      $(e.target).click();
      
      $('.product_gallery_nav').find('.gallery-cell').each((i, el) => {
        if(el.classList.contains('is-nav-selected')) {
          announceToScreenReader(`You are on slide ${i + 1}`);
          return
        }
      });
    }
    
    slide.addEventListener('click',handleClick);
    slide.removeAttribute('aria-selected');
    
    const observer = new MutationObserver((mutations) => {
      slide.removeAttribute('aria-selected');
      
        if(slide.classList.contains('is-nav-selected')) {
          slide.setAttribute('aria-current', true);
          // slide.focus();
        } else {
          slide.removeAttribute('aria-current')
        }
    
        });
  
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['class']
      })
    });

      
    $("h1,h2,h3,h4,h5,h6").each((i, title) => {
      const content = title.textContent.trim();
      
      if(!content || content === "" || content === " " || content === "&nbsp;") {
        title.setAttribute('role','none');
      }
    });

  $('.search-radius-box').each((i, container) => {
    const label = $(container).find('#radius-value');

    $(container).find('#radius_search').each((i, input) => {
      function handleChange() {
        input.setAttribute('aria-label', `${label.text().replace(/\s\s+/g, " ").trim()} slider`); 
      }
      
      input.addEventListener('change', (e) => {
        handleChange();
      });

      handleChange();
    });
  });

  $("h1,h2,h3,h4,h5,h6").each((i, title) => {
    if($(title).parent().hasClass('shg-product-title-component')) {
      return
    }
    
    const content = title.textContent.trim();
  
    if (content === "" || content === " " || content === "&nbsp;") {
      title.remove()
    }
  });


  $('#mobile_menu').each((i, menu) => {
    $(menu).find('.sublink').each((i, li) => {
      const anchor = $(li).children('a');
      const submenu = $(li).children('ul');
      const isMobile = window.matchMedia("(max-width: 767px)");
      const icon = anchor.find('.icon-down-arrow');

      if (isMobile.matches) {
        icon.insertAfter(anchor);
        
        icon.attr({
          'role': 'button',
          'tabindex': 0,
          'aria-label': `${anchor.text().trim()} submenu`
        });

        icon.attr('aria-expanded', submenu.css('display') === 'block');

        icon.on('click', (e) => {
          e.preventDefault();
          submenu.toggle();
          icon.attr('aria-expanded', submenu.css('display') === 'block');
        });

        icon.on('keydown', (e) => {
          if(e.key === 'Enter') {
            icon.click();
          }
        });
      }
    })
  });

  $('#cart_form').each((i, cart) => {
    const subtotal = $(cart).find('.cart_subtotal');
    const text = subtotal.find('span').last();
    
    subtotal.find('.right').appendTo(subtotal);
    text.wrap(`<p></p>`);
  });




  $('form.search__form').each((i, form) => {
    const input = form.querySelector('input[name="q"]');

    if(!input) {
      return
    }

    const id = randomId();
    
    input.setAttribute('id', id);
    
    const label = $(`<label class="search__form-label sr-only" for="${id}">${input.getAttribute('placeholder')}</label>`);

    label.insertBefore(input);
  });

  $('table#customer-orders').each((i, table) => {
    const label = $(table).siblings('h4');
    $(table).prepend(`<caption class="sr-only">${label.text().trim()}</caption>`);

    $(table).attr({
      'role': 'table'
    });

    $(table).find('thead, tbody, tfoot, tr, th, td').attr('role', function() {
      if ($(this).is('table')) {
        return 'table';
      } else if ($(this).is('thead')) {
        return 'rowgroup';
      } else if ($(this).is('tbody')) {
        return 'rowgroup';
      } else if ($(this).is('tfoot')) {
        return 'rowgroup';
      } else if ($(this).is('tr')) {
        return 'row';
      } else if ($(this).is('th')) {
        return 'columnheader';
      } else if ($(this).is('td')) {
        return 'cell';
      }
    });

    $(table).find('thead tr th').attr('scope', 'col');
  });

  isElementVisible(".bundles-bundler-hop-full-page-overlay", document.querySelector('body')).then((popup) => {
    setTimeout(() => {
      const disabledElement = popup.find('.bndlr-product[data-required="true"]');
      const disbledItems = disabledElement.find(focusableSelector);

      disbledItems.attr({
        'tabindex': -1
      });
      
      const focusableElements = popup.find(focusableSelector);
      focusableElements.first().focus();
      trapFocus(popup);

      const close = popup.find('.bundles-bundler-hop-x-button');
      const addToCart = popup.find('.bndlr-add-to-cart, .bundles-bundler-hop-button-to-checkout');

      if(addToCart.length < 1) {
        return
      }
   
      close.attr({
        'tabindex': 0,
        'aria-label': 'Close',
        'role': 'button'
      });

      popup.find('.bndlr-old-price').each((i, price) => {
        $(price).prepend(`<span class="sr-only">Actual Price: </span>`);
      });
      
      popup.find('.bndlr-new-price').each((i, price) => {
        $(price).prepend(`<span class="sr-only">Discounted Price: </span>`);
      });

      addToCart.on('click', (e) => {
        announceToScreenReader('Loading');
      });

      popup.find('.bundles-bundler-hop-close-offer, .bundles-bundler-hop-button-to-checkout').attr({
        'role': 'button'
      });

      const observer = new MutationObserver((mutations) => {
        for(const mutation of mutations) {
          for(const node of mutation.addedNodes) {
            if(node && node.nodeType === 1 && node.classList.contains('bndlr-checkmark')) {
              alert('Item added to cart')
            }
          }
        }
      });

      const bndlrAddToCart = popup.find('.bndlr-add-to-cart');

      if(bndlrAddToCart.length > 0) {
        observer.observe(bndlrAddToCart.get(0), {
          childList: true,
          subtree: true
        })
      }

    }, 2000);
  });


  $('.VueTables').each((i, VueTables) => {
    const heading = $(VueTables).siblings('h1');

    if(heading.length < 1) {
      return
    }

    heading.attr({
      'role': 'heading',
      'aria-level': 2
    })

    const table = $(VueTables).find('table');
    const caption = $(`<caption class="sr-only">${heading.text().trim()}</caption>`);

    table.prepend(caption);

    function handleChange() {
      table.find("tr").attr({
        role: "row"
      });
      
      table.find("thead th").attr({
        scope: "col",
      });
  
      table.find("tbody tr td").attr({
        role: "gridcell"
      });
    }
    
    const observer = new MutationObserver((mutations) => {
      handleChange();
    });

    observer.observe(VueTables, {
      childList: true,
      subtree: true
    });
    
  });

  $('.page_audeze-hq-presets__table').each((i, wrapper) => {
    const table = $(wrapper).find('table');
    const caption = $('.page_audeze-hq-presets__intro').find('h2');

    table.find("thead td").attr({
      role: 'columnheader',
      scope: "col",
    });
    
    table.prepend(`<caption class="sr-only">${caption.text()}</caption>`);
  });

  $('.page-gaming__audiophile').each((i, section) => {
    const items = $(section).find('.page-gaming__audiophile-item');

    items.each((i, item) => {
      const heading = $(item).find('h2');
      const anchor = $(item).find('.shg-btn');

      heading.find('br').replaceWith(' ');

      const hiddenHeading = $(`<h2 class="sr-only">${heading.first().text().trim()} ${heading.last().text().trim()}</h2>`)

      heading.first().attr({
        'aria-hidden': true
      });

      heading.last().attr({
        'aria-hidden': true
      });

      hiddenHeading.insertBefore(heading.first());
      
      anchor.attr('aria-label', `${anchor.text().trim().toLowerCase()} ${heading.first().text().trim().toLowerCase()} ${heading.last().text().trim().toLowerCase()}`);
    });
  });

  $('.lcd-flagship__section-buy-now').each((i, item) => {
    const heading = $(item).find('h3');
    const anchor = $(item).find('.shg-btn');

    heading.find('br').replaceWith(' ');
    anchor.attr('aria-label', `${heading.first().text().trim().toLowerCase()} ${anchor.text().trim().toLowerCase()}`);
  });

  $('[data-page-url="/collections/apparel"] .product-info__caption .product-details .title').attr({
    'role': 'heading',
    'aria-level': 2
  });

  $('.shg-lightbox').each((i, shgLightbox) => {
    const close = $(shgLightbox).find('.shg-lightbox-close');

    close.attr({
      'aria-label': 'Close'
    })
  });

  $('.page_mobius__feature-item').each((i, item) => {
    $(item).find('h3').removeAttr('aria-level').removeAttr('role');
  });

  $('.convert-p-to-heading-1 p').attr({
    'role': 'heading',
    'aria-level': 1
  });

  $('.crbn__read-story a br').attr({
    'aria-hidden': true
  });

  $('.play-video__section').each((i, hero) => {
    const title = $(hero).find('.shg-theme-text-content > p:first-child > strong, .shg-theme-text-content > p:first-child > span, .shg-theme-text-content h3');
    const button = $(hero).find('[id^="myBtn"]');

    button.attr({
      'aria-label': `${title.text().trim()} ${button.text().trim().replace('▷ ', '')}`
    });
  });

  $('.product_reveal__specs-table table').each((i, table) => {
    $(table).find('thead tr th:first-child').attr({
      'role': 'heading',
      'aria-level': 3
    });
  });

  $(".yotpo-empty-state svg").attr("aria-hidden", "true");

$('[data-page-url="/collections/apparel/products/audeze-lcd-grille-logo-t-shirt-heather"] .description h6,[data-page-url="/collections/apparel/products/audeze-retro-cord-and-grille-heather"] .description h6,[data-page-url="/collections/apparel/products/audeze-maxwell-t-shirt-heather"] .description h6').attr('role','none');
  $('[data-page-url="/products/reveal"] h3,[data-page-url="/collections/accessories/products/lcd-combo-cable"] h3,[data-page-url="/collections/accessories/products/copy-of-aluminum-travel-case-for-lcd-5-crbn-mm-series"] h3,[data-page-url="/collections/accessories/products/euclid-silicone-eartip-set"] h3,[data-page-url="/collections/accessories/products/lcd-standard-travel-case"] h3').attr({'role':'heading','aria-level':'2'});
 setTimeout(()=>{
   $('[data-page-url="/products/reveal"] .zoomImg').attr('alt','');
   $('[data-page-url="/products/reveal"] .paywhirl-plan-selector-icon svg,[data-page-url="/collections/accessories/products/mobius-cable-kit"] .yotpo-bold-layout svg,[data-page-url="/collections/accessories/products/copy-of-aluminum-travel-case-for-lcd-5-crbn-mm-series"] .yotpo-bold-layout svg,[data-page-url="/collections/accessories/products/euclid-silicone-eartip-set"] .yotpo-bold-layout svg,.yotpo-bold-layout.yotpo-main-reviews-widget svg').attr('aria-hidden','true');
   $('.yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-new-review').attr('role','button');
   document
  .querySelectorAll('.shg-c.accordian-secondary h4.shogun-accordion-title')
  .forEach(el => {
    el.setAttribute('role', 'heading');
    el.setAttribute('aria-level', '2');
  });
 },3000);
 $('[data-shogun-page-id="6425c93d58ccc700f5ac6984"] h4').attr({'role':'heading','aria-level':'2'});
$('[data-page-url="/collections/legacy-products"] .product-wrap .product_image a').removeAttr('href');
$('[data-page-url="/pages/european-distribution"] .one-whole h2').attr({'role':'heading','aria-level':'1'});


    $('[data-page-url="/products/reveal"] .paywhirl-info-popup svg,[data-page-url="/products/reveal"] label svg').attr('aria-hidden','true');
 
  $('.mm-series__blurb').each((i, blurb) => {
    const h2 = $(blurb).find('h2');
    const clone = h2.clone();
    
    clone.find('br').replaceWith(function() {
      return ' ';
    });

    const hidden = $(`<h2 class="sr-only">${clone.text().trim()}</h2>`);

    h2.attr({
      'aria-hidden': true
    });

    hidden.insertBefore(h2);
  });

  $('.audeze_learn-more___button').each((i, button) => {
    const content = $('.audeze_learn-more___content').eq(i);
    const h2 = content.find('h2, .collection_title');
    const anchor = $(button).find('a');

    anchor.attr({
      'aria-label': `${anchor.text().trim()} about ${h2.text().trim()}`
    })
  });

  $('footer').each((i, footer) => {
    $(footer).find('a[href^="tel:"], a[href^="mailto:"]').each((i, a) => {
      if(a.textContent === "") {
        $(a).replaceWith( "<br>" );
      }
    });
  });

  $('.products-slider[tabindex]').removeAttr('tabindex');

  $('.a11y_h6_h2 h6').attr({'role':'heading','aria-level':'2'});
  $(".a11y_bundle_learnmore a").attr('aria-label',"Learn more about Bundle with Reveal+");

   $('.a11y_series_link').each(function() {
        var text1 = $(this).find('.a11y_series_text .text1').text().trim();
        var text2 = $(this).find('.a11y_series_text .text2').text().trim();
        var linktext = $(this).find('.a11y_series_linktext a.shg-btn.shg-cse ').text().trim();
        $(this).find('.a11y_series_linktext a.shg-btn.shg-cse ').attr('aria-label', linktext+ ' ' +text1 + ' ' +text2+' ' );
    });

  
  $(".a11_rem_role a").attr("aria-label","Shop the Gaming Series The World’s Best Gaming Headsets");
  $(".a11y_custom_heading h4.shogun-accordion-title").attr({'role':'heading','aria-level':'2'});

  $('.search-container').each((i, container) => {
    const button = $(container).find('.icon-search.search-submit');
    const input = $(container).find('input');
    const form = $(container).find('.search__form');
    
      button.last().attr({
          tabindex: 0,
          role: 'button',
          'aria-label':'Search'
      });
  
      button.last().on('keydown', (e) => {
          if(e.key === 'Enter') {
              e.target.click();
          }
      });

    button.last().appendTo(form)
  });

 $(".a11y_h6_h1 h6").attr({'role':'heading','aria-level':'1'});
 $('[data-page-url="/account/login"]').each(function () {
   
   var heading = $(this).find('h1');
   var title = $(this).find('head title');
   title.text(`${heading.text()} - ${title.text().split('-')[1]}`);
 });

  $(".a11y_headings strong").attr({'role':'heading','aria-level':'2'});
  $("#customer_login").prepend(`<div>* = required</div>`);

  $('.nav-desktop').each((i, nav) => {
    const items = $(nav).find('ul > li.nav-desktop__tier-1-item');
    const ul = $(nav).find('ul.nav-desktop__tier-1');

    items.each((i, item) => {
      const icon = $(item).find('.icon-down-arrow');
      const details = $(item).find('details');
      const anchor = $(item).find('.nav-desktop__tier-1-link');
      const submenu = details.find('[data-nav-desktop-submenu]');

      function handleChange() {
        anchor.attr({
          // 'role': 'link',
          'aria-haspopup': true,
        })

        anchor.removeAttr('aria-expanded');
        anchor.removeAttr('aria-controls');
      }

      const observer = new MutationObserver((mutations) => {
        handleChange();
      });

      observer.observe(anchor.get(0), {
        attributes: true,
        attributeFilter: ['class', 'aria-expanded']
      });

      handleChange();
    });



    $(nav).find('a.nav-desktop__tier-1-link').removeAttr('aria-haspopup');
  });

  console.log( "ready!" );
});

$(window).on("load", function() {
    function handleSkipToMain() {
      const skipToMain = $(`<a href="#content" class="skip-to-main">Skip To Main Content</a>`);
      $('body .shopify-section--header').prepend(skipToMain);
    }

    handleSkipToMain();

    $('.banner.homepage-slideshow').removeAttr('tabindex');

    $('.section-wrapper').attr({
      'id': 'content'
    });

    isElementVisible(".cc-window", document.querySelector('body')).then((el) => {
      el.removeAttr('tabindex');

      const svgs = document.querySelectorAll('#Capa_1');
      const wrapper = el.find('.cookieconsent-wrapper');
      const close = wrapper.find('.isense-close-icon');

      $('.cookie-settings-header').attr({'role':'heading','aria-level':'2'});
      $('.cc-checkbox-container span.cc-checkbox').attr('aria-hidden','true');
      
      $('.main-information .cc-checkbox-container').each(function(){
        $(this).find('.cc-btn-cookie-info-container').appendTo($(this).find('label').parent());
      });

      if(svgs.length > 0) {
        svgs.forEach((svg, i) => {
          svg.removeAttribute('id');
        })
      }

      close.on('keyup', (e) => {
        if(e.key === 'Enter') {
          e.target.click()
        }
      });

      el.find('.cc-settings').on('click', (e) => {
        $('.cc-settings-view').removeAttr('aria-hidden');
      });

      function handleChange() {
        if(!el.hasClass('cc-invisible')) {
          trapFocus(wrapper);
          wrapper.parents().siblings().attr("aria-hidden", "true");
          wrapper.find(focusableSelector).first().focus();
        } else {
          wrapper.parents().siblings().removeAttr("aria-hidden");
        }
      }
      
      const observer = new MutationObserver((mutations) => {
        $('#Capa_1').removeAttr('id');
        handleChange();
      });

      observer.observe(el.get(0), {
        attributes: true,
        attributeFilter: ['class']
      });

      handleChange();

      $('.btn[onclick="showPreferences();"]').each((i, button) => {
        button.addEventListener('click', (e) => {
          queueMicrotask(() => {
            const settings = $('.cc-settings-view .main-information');
            trapFocus(settings);
          })
        })
      });

      function triggerClick(e) {
        if(e.key === 'Enter') {
          e.target.click();
        }
      }

     $([
       '.cc-settings-view #strict_cookies_info', 
       '.cc-settings-view #marketing_cookies_info', 
       '.cc-settings-view #functionality_cookies_info', 
       '.cc-settings-view #analytics_cookies_info'
     ].join(',')).each((i, cookiePanel) => {
      const observer = new MutationObserver((mutations) => {
        if(cookiePanel.classList.contains('show-isense')) {
          const header = $(cookiePanel).find('.cookie-settings-header');
          const body = $(cookiePanel).find('.cookies-info');

          body.attr({
            'tabindex': 0
          });
          
          trapFocus(cookiePanel);
          
          header.attr('tabindex', -1).focus();

          header.on('keydown', (e) => {
            if(e.key === 'Tab' && !e.shiftKey) {
              console.log($(cookiePanel).find('.cc-btn'))
              header.removeAttr('tabindex');
              $(cookiePanel).find('.cc-btn').focus();
            }
          })
        }

      });

       observer.observe(cookiePanel, {
         attributes: true,
         attributeFilter: ['class']
       })
     });

      const moreBtns = document.querySelectorAll('.cc-btn-cookie-info-container');
      if(moreBtns.length > 0) {
        moreBtns.forEach((button, i) => {
          button.addEventListener('keydown', (e) => {
            if(e.key === 'Enter') {
              e.target.click();
            }
          })
        })
      }

      const closeBtns = document.querySelectorAll('.cc-btn-close-info');
      if(closeBtns.length > 0) {
        closeBtns.forEach((button, i) => {
          button.addEventListener('keydown', (e) => {
            if(e.key === 'Enter') {
              e.target.click();
            }
          })
        })
      }
      
    });



  $('.product_gallery_nav').removeAttr('tabindex');

  $('.shg-sld-dots').each((i, dots) => {

    function handleClick() {
      $(dots).find('.shg-sld-dot').each((index, element) => {
          if(element.classList.contains('shg-sld-active')) {
            announceToScreenReader(`You are on slide ${index + 1}`);
            return
          }
      });
    }
    
    $(dots).find('.shg-sld-dot').each((i, dot) => {
      $(dot).attr({
        'tabindex': 0,
        'role': 'button',
        'aria-label':`Slide ${i + 1}`
      });
  
      $(dot).on('click', () => {
        setTimeout(() => {
          handleClick();
        }, 500);
      });
  
      dot.addEventListener('keyup', (e) => {
        if(e.key === 'Enter') {
          e.target.click();
        }
      })
  
      function handleChange() {
        if(dot.classList.contains('shg-sld-active')) {
          dot.setAttribute('aria-current', true)
        } else {
          dot.removeAttribute('aria-current')
        }
      }
      
      const observer = new MutationObserver((mutations) => {
        handleChange();
      });
  
      observer.observe(dot, {
        attributes: true,
        attributeFilter: ['class']
      });
  
      handleChange();
    });
  });

  $('.flickity-slider .gallery-cell.is-selected > a').each((i, el) => {
    $(el).attr('role', 'button');

    function handleChange() {
      setTimeout(() => {
        const fancybox = $('.fancybox-stage');
        const content = fancybox.find('.fancybox-content');
        const prev = fancybox.find('.fancybox-prev');
        const next = fancybox.find('.fancybox-next');
        const close = fancybox.find('.fancybox-close-small');

        prev.off('click');
        prev.on('click', () => {
          announceToScreenReader('Slide Changed');
          handleChange();
        });

        next.off('click');
        next.on('click', () => {
          announceToScreenReader('Slide Changed');
          handleChange();
        });

        close.prependTo(content);
      }, 500);
    }
    
    $(el).on('click', (e) => {
      handleChange();
    });
  });

  $('.flickity-page-dots .dot').each((i, button) => {
    $(button).attr({
      'role': 'button',
      'tabindex': 0,
      'aria-label': `slide ${i + 1}`
    });
    

    button.addEventListener('keydown', (e) => {
      if(e.key === 'Enter') {
        button.click();
      }
    })
  });


  $('div[data-shg-href]').each((i, el) => {
    const anchor = $(`<a class="invisible" href="${$(el).attr('data-shg-href')}" target="${$(el).attr('data-shg-href-target')}"></a>`);
    anchor.insertBefore(el);

    $(el).attr({
      'tabindex': 0,
      'role': 'link'
    });
    
    el.addEventListener('keydown', (e) => {
      if(e.key === 'Enter') {
        anchor.get(0).click();
      }
    });
  });

  function handleQuickShopButton() {
    setTimeout(() => {
      const lightbox = $('.quick-shop__lightbox');
      const close = lightbox.find('.fancybox-button.fancybox-close-small');
      const moreLink = lightbox.find('a[href$="/pages/revealdownload"]:contains(" "), a[href$="/pages/revealdownload"]:empty');
      const slider = lightbox.find('.flickity-slider');

      moreLink.remove()

      lightbox.find('a[href$="/pages/revealdownload"]').attr({
        'aria-label': 'More options'
      });
      
      lightbox.find('.product_gallery_nav').removeAttr('tabindex');
      lightbox.find('.shopify-payment-button__more-options').attr('role','link'); 
      lightbox.find('.product-gallery__thumbnails .gallery-cell').each((i, thumbnail) => {
        $(thumbnail).attr('role','button');

        thumbnail.addEventListener('click', (e) => {
          thumbnail.focus();
        });
      });

      close.on('click', (e) => {
        setTimeout(() => {
          $('.product__details .js-quick-shop-link').on('click', handleQuickShopButton);
        }, 1000)
      });

      const slides = lightbox.find('.gallery-cell');

      slides.each((i, slide) => {
        slide.removeAttribute('aria-selected');
      
        const observer = new MutationObserver((mutations) => {
          slide.removeAttribute('aria-selected');
        
          if(slide.classList.contains('is-nav-selected')) {
            slide.setAttribute('aria-current', true);
            // slide.focus();
          } else {
            slide.removeAttribute('aria-current')
          }
        });

        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['class']
        })
      });

      $('.flickity-prev-next-button').each((i, button) => {
        $(button).off('click');
        $(button).on('click', (e) => {
          $(slider).find('.gallery-cell:not(.product-gallery__thumbnail)').each((i, el) => {
            if(el.classList.contains('is-selected')) {
              announceToScreenReader(`You are on slide ${i + 1}`);
              return
            }
          });
        });
      });

      function handleClick(e) {
        e.preventDefault();
        $(e.target).click();
        
        $(slider).find('.gallery-cell:not(.product-gallery__thumbnail)').each((i, el) => {
          if(el.classList.contains('is-selected')) {
            announceToScreenReader(`You are on slide ${i + 1}`);
            return
          }
        });
      }
    }, 2000);
  }
  
   $('.product__details .js-quick-shop-link').on('click', handleQuickShopButton);

  $('.product__details').each((i, el) => {
    const caption = $(el).find('.product-details .title');
    const button = $(el).find('.info > button.quick_shop');

    button.attr('aria-label', `${caption.text().trim()} ${button.text().trim()}`);
  })

  function fixQuantityButtons(container = $(document)) {
    $('.product-quantity-box').each((i, quanitity) => {
      const buttonMinus = $(quanitity).find('.ss-icon.product-minus'); 
      const buttonPlus = $(quanitity).find('.ss-icon.product-plus'); 
      const input = $(quanitity).find('input.quantity');
      const label = $(quanitity).find('label');
      const id = randomId();

      input.attr("aria-live","polite");

      if(buttonMinus.attr('data-a11y-updated')) {
        return
      }

      function handleChange(inital=false) {
        buttonMinus.attr({
          // 'aria-label': `Decrease Quantity`
        });

        buttonPlus.attr({
          // 'aria-label': `Increase Quantity`
        });

        if(parseInt(input.val()) <= 1) {
          buttonMinus.attr('aria-disabled', true);
          buttonMinus.removeAttr('tabindex');

          if(!inital) {
            input.focus();  
          }
          
        } else {
          buttonMinus.attr('tabindex', 0);
          buttonMinus.removeAttr('aria-disabled');
        }
      }
      
      
      input.on('change', (e) => {
        handleChange();
      });
      
      $(quanitity).find('.ss-icon').each((i, button) => {
        $(button).attr({
          'role': 'button',
          'tabindex': 0
        });

        $(button).off('keydown');
        
        $(button).on('keydown', (e) => {
          if(e.key === 'Enter') {
            e.preventDefault();
            $(button).click();
          }
        });
      });

      buttonMinus.attr({
        'data-a11y-updated': true
      });

      input.attr({
        'id': id
      });

      label.attr({
        'for': id
      });

      handleChange(true);
      
    });
  }

  fixQuantityButtons();

  
  function fixPaymentButtons() {
    $('form[action$="payments.amazon.com/checkout/signin"]').each((i, form) => {
      $(form).find('button[type="submit"]').attr({
        'role': 'link'
      });
    });
  
    $('.shopify-payment-button__button [role="button"]').attr({
      'role': 'link'
    });
  }

  fixPaymentButtons();

  $('.cart-container').each((i, container) => {
    const form = $(container).find('form');
    const trigger = $(container).find('a.dropdown_link');
    const cartFocusable = $(container).find('.cart_content').find(focusableSelector);
    const continueShopping = $(container).find(".cart_content__continue-shopping");
    const closeBtn = $(`<button aria-label="Close Cart Overlay" class="cart_content__close"></button>`);
    const isMobile = window.matchMedia("(max-width: 767px)");

    if(isMobile.matches) {
      closeBtn.insertAfter(continueShopping);
      continueShopping.add(closeBtn).wrapAll('<div class="cart_content__continue-shopping-wrap"></div>');
    }

    cartFocusable.last().on("keydown", (e) => {
      if (e.originalEvent.key === "Tab" && !e.originalEvent.shiftKey) {
        e.preventDefault();
        container.classList.remove('active_link')
      }
    });

    trigger.on('focus', () => {
      container.classList.add('active_link');
    });

    trigger.on('keydown', (e) => {
      if (e.originalEvent.key === "Tab" && e.originalEvent.shiftKey) {
        container.classList.remove('active_link')
      }
    });

    continueShopping.attr({
      'role': "heading",
      "aria-level": 2,
    });

    closeBtn.on('click', (e) => {
      e.preventDefault();
      container.classList.remove('active_link')
    })

    $(window).on('keydown', (e) => {
      if(e.key === 'Escape' && container.classList.contains('active_link')) {
        trigger.focus();
        container.classList.remove('active_link')
      }
    });

    function handleChange() {
      const inputs = form.find('input.quantity');

      inputs.each((i, input) => {
        input.removeAttribute('aria-live');
      })
      var count = $(container).find("a.icon-cart").text().trim();
      $(container).find("a.icon-cart").attr("aria-label","Cart "+count+" items");
      
    }

    const observer = new MutationObserver((mutations) => {
      for(const mutation of mutations) {
        if(mutation.target.classList.contains('cart_items')) {
          handleChange();
          fixQuantityButtons(container);
        }
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });

    handleChange();
    
  })
  
   setTimeout(function() {
      $('#shopify-product-reviews a.spr-summary-actions-newreview').attr({
         'role': 'button',
         'aria-expanded': 'false'
      });
      $("#shopify-product-reviews a.spr-summary-actions-newreview").click(function() {
         $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
      });



     $('.spr-reviews').each((i, reviews) => {
       function handleChange() {
          $(reviews).find('.spr-pagination').each((i, pagination) => {
            $(pagination).attr({
             'role': 'navigation',
             'aria-label': 'Pagination'
            });
            
            $(pagination).find('> div').attr({
             'role': 'list'
            });
            
            $(pagination).find('.spr-pagination-page').each((i, page) => {
              const linktext = $(page).text().trim();
              const link = page.querySelector('a');
              let mainElement = $(page);
              
              $(page).attr({
                'role': 'listitem'
              });

              if(!link) {
                mainElement = $(page);
              } else {
                mainElement = $(link)
              }
              
              if(mainElement.find('.page-label').length < 1) {
                const clone = mainElement.clone();
                mainElement.text('')
                mainElement.prepend(`<span class="sr-only page-label">Customer reviews page ${clone.text()}</span>`);
                mainElement.append(`<span aria-hidden="true">${clone.text()}</span>`);
              }

              $(reviews).find('.spr-pagination .spr-pagination-page.is-active .sr-only').each((i, span) => {
                if(!$(span).text().includes('current')) {
                  $(span).text(`current ${$(span).text()}`);
                }
              });
              
            });
          });

         $(reviews).find('.spr-review').each((i, review) => {
           const title = $(review).find('.spr-review-header-title');
           const report = $(review).find('.spr-review-reportreview');

           report.attr({
             'aria-label': `${title.text().trim()} ${report.text().trim()}`,
           });
           
           $(review).find('.spr-review-reportreview').click(function() {
              setTimeout(function() {
                $(review).find('span.spr-review-reportreview').removeAttr('aria-label');
                $(review).find('span.spr-review-reportreview').attr('tabindex','-1');
                $(review).find('span.spr-review-reportreview').focus();
              }, 1000);
           });
         });
         
       }
       
       const observer = new MutationObserver((mutations) => {
         handleChange();
       });

       handleChange();
       
       observer.observe(reviews, {
         childList: true,
         subtree: true
       })
     });
     
     // $('.flickity-slider .gallery-cell').removeAttr("aria-selected");
     $('input[name="review[author]"]').attr('autocomplete','name');
     $('input[type="email"]').attr('autocomplete','email');

      $('.product-recommendations, .product-list--collection, .slider-gallery.products-slider').each((i, list) => {
        function handleChange() {
          $(list).find('.product__details, .product-wrap').each((i, product) => {
            $(product).find('.thumbnail-overlay .hidden-product-link').attr({
              'tabindex': -1
            });
          });  
        };

        handleChange();
        
        const observer = new MutationObserver((mutations) => {
          handleChange();
        });

        observer.observe(list, {
          childList: true,
          subtree: true,
        })
      });

     


   }, 2000);



  function handleFancyContainer() {
    const lightbox = $('.quick-shop__lightbox');
    const close = lightbox.find('.fancybox-button.fancybox-close-small');
    const productId = lightbox.find('.product_gallery[data-product-id]').attr('data-product-id');

    lightbox.find('.product_gallery[tabindex]').removeAttr('tabindex');
    
    close.off('click');
    
    if(productId && productId.length > 0) {
      close.on('click', (e) => {        
        $(`.js-quick-shop-link[data-id="${productId.trim()}"]`).focus();
      });
    }
    
    const select = lightbox.find('select.single-option-selector');
    const label = $(`<label for="${select.attr('id')}">Select Product Variant</label>`);

    if($(`label[for="${select.attr('id')}"]`).length < 1) {
      label.insertBefore(select); 
    }

    fixQuantityButtons(lightbox);
    
    var r_link_text= $('#quickshop h2.product_name').text().trim();
    $('#quickshop .description p > a').attr('aria-label','Click here for more information about the'+' '+r_link_text);
    
    $("a").each((i, title) => {
		const content = title.textContent.trim();
		if(!content || content === "" || content === " " || content === "&nbsp;") {
			title.style.display = "none"
		}
	});
   
    setTimeout(function () {
      $('.fancybox-prev').attr({
        'role':'button',
        'aria-label':'Previous'
      });
      
      $('.fancybox-next').attr({'role':'button','aria-label':'Next'});
    }, 500);

    setTimeout(function () {
      fixPaymentButtons();
    }, 1000);
  }
  
    const bodyObserver = new MutationObserver((mutations) => {
      for(const mutation of mutations) {
        for(const node of mutation.addedNodes) {
          if(node && node.nodeType === 1 && node.classList.contains('fancybox-container')) {
            handleFancyContainer();
          }
        }
      }
    });
    
    bodyObserver.observe(document.body, {
      childList: true,
    });


    // Other A11y: Home: Elements must only use allowed ARIA attributes
  
    $('.product_gallery:not(.product-gallery__thumbnails), .homepage-slideshow').each((i, slider) => {
      
      const slides = $(slider).find('.gallery-cell');

      slides.each((i, slide) => {
        slide.removeAttribute('aria-selected');
        slide.removeAttribute('data-title');
        
        const observer = new MutationObserver((mutations) => {
          slide.removeAttribute('aria-selected');
        });

        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['class']
        })
      });

      function handleClick(e) {
        e.preventDefault();
        $(e.target).click();
        
        $(slider).find('.gallery-cell:not(.product-gallery__thumbnail)').each((i, el) => {
          if(el.classList.contains('is-selected')) {
            announceToScreenReader(`You are on slide ${i + 1}`);
            return
          }
          
        });
      }

      $(slider).find('.flickity-page-dots .dot').each((i, button) => {
        button.addEventListener('click', handleClick);

        const observer = new MutationObserver((mutations) => {
          if(button.classList.contains('is-selected')){
            button.setAttribute("aria-current", true);
          }
        });

        observer.observe(button, {
          attributes: true,
          attributeFilter: ['class']
        });
        
      });

      const prev = $(slider).find('.flickity-prev-next-button.previous');
      const next = $(slider).find('.flickity-prev-next-button.next');

      prev.off('click');
      next.off('click');
     
      prev.add(next).off('click');
      prev.add(next).on('click', function (e){
        e.preventDefault();
        slides.each(function (index, slide) {
          if(slide.classList.contains('is-selected')){
            announceToScreenReader(`You are on slide ${index + 1}`);
            return
          }
        });
      });
  });

  $('.product_gallery_nav.product-gallery__thumbnails').each((i, slider) => {
    let active = 1;

    $(slider).find('.flickity-prev-next-button.previous').on('click', () => {
      active = active - 1;
      announceToScreenReader(`You are on slide ${active}`);
    });
    
    $(slider).find('.flickity-prev-next-button.next').on('click', () => {
      active = active + 1;
      announceToScreenReader(`You are on slide ${active}`);
    });
  });

  $('.product_gallery .lightbox').each((i, lightbox) => {
    const img = $(lightbox).find('.product-gallery__image');
    
    const observer = new MutationObserver((mutations) => {
      lightbox.removeAttribute('style');
    });

    observer.observe(lightbox, {
      attributes: true,
      attributeFilter: ['style']
    });

    function handleLightbox(params) {
      const popup = document.querySelector('.product-section__lightbox');

      if(!popup) {
        return
      }

      const inner = popup.querySelector('.fancybox-inner');
      const closeBtns = popup.querySelectorAll('.fancybox-button--close, .fancybox-close-small');
      const bg = popup.querySelector('.fancybox-bg');

      $(popup).find('.zoomImg').attr({
        'aria-hidden': true
      });

      $(popup).find('.fancybox-image').attr({
        'alt': img.attr('alt')
      });

      $(inner).parents().siblings().attr("aria-hidden", true);

      closeBtns.forEach((close, i) => {
        close.addEventListener('click', () => {
          $(inner).parents().siblings().removeAttr("aria-hidden");
        });
      });

      inner.addEventListener('click', (e) => {
        const container = $(popup).find(".fancybox-content");
        
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          console.log(container)
          $(inner).parents().siblings().removeAttr("aria-hidden");
        }
      })
    }

    lightbox.addEventListener('click', (e) => {
      setTimeout(() => {
        handleLightbox();
      }, 500)
    })
  });

  $('.homepage-slideshow').each((i, slider) => {
    $(slider).find('.flickity-slider > .gallery-cell').each((i, slide) => {
      const button = $(slide).find('.global-button--banner:contains("LEARN MORE")');

      if(button.length < 1) {
        return
      }

      const img = $(slide).find('.image-element__wrap > img');
      const alt = img.attr('alt');
      
      if(alt.length > 0) {
        button.attr({
          'aria-label': `${alt} ${button.text().trim()}`
        })
      }
    });
  });

  $('[data-nav-desktop-link][aria-controls]').each((i, link) => {
    const id = link.getAttribute('aria-controls');
    const panel = $(link).siblings(`#${id}`);

    if(panel.length < 1) {
      return
    }

    $(link).attr({
      'aria-controls': `${id}-${i}`
    });

    panel.attr({
      'id': `${id}-${i}`
    })
  })


  $('ul.dropdown_title').each((i, ul) => {
    $(ul).attr({
      'role': 'none'
    });

    $(ul).find('li').attr({
      'role': 'none'
    })
  });

  setTimeout(() => {
    $('#shopify-product-reviews').each((i, form) => {
      const radioId = randomId();
      
      function handeSubmit() {
        setTimeout(() => {
          const error = $('.spr-form-message-error');
          
          error.attr({
            'tabindex': -1
          });

          error.focus();
        }, 1000)
      }

      function handleChange() {
        
        const submit = $('input[type="submit"].spr-button');
        
        if(submit.length > 0) {
          submit.on('click', handeSubmit);
        }
  
        $(form).find('input.spr-form-input, textarea.spr-form-input, select.spr-form-input').attr({
          'required': 'required'
        });
        
        $(form).find('label[for="review[rating]"]').attr({
            'id': radioId
        }).removeAttr('for');
        
        $(form).find('.spr-starrating').each((i, rating) => {
          $(rating).attr({
            'role': 'radiogroup'
          });

          const icons = rating.querySelectorAll('a.spr-icon');

          if(icons.length > 0) {
            icons.forEach((star, i) => {
              star.setAttribute('aria-required', true);
              star.setAttribute('role', 'radio');
              star.setAttribute('aria-labelledby', radioId);
              star.removeAttribute('aria-label')
              
              if(star.classList.contains('spr-icon-star-empty')) {
                star.setAttribute('aria-checked', false);
              } else {
                star.setAttribute('aria-checked', true);
                 
              }
  
              star.addEventListener('keydown', (e) => {
                const activeIcon = document.activeElement;
                const iconsArray = Array.from(icons);
                const activeIndex = iconsArray.indexOf(activeIcon);
                
                if(e.key === 'ArrowDown') {
                  e.preventDefault();
                  if(activeIndex < icons.length - 1) {
                    icons[i + 1].focus();
                    icons[i + 1].click();
                  }
                } else if(e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(activeIndex > 0) {
                    icons[i - 1].focus();
                    icons[i - 1].click();
                  }
                } else if(e.key === 'ArrowRight') {
                  e.preventDefault();
                  if(activeIndex < icons.length - 1) {
                    icons[i + 1].focus();
                    icons[i + 1].click();
                  }
                } else if(e.key === 'ArrowLeft') {
                  e.preventDefault();
                  if(activeIndex > 0) {
                    icons[i - 1].focus();
                    icons[i - 1].click();
                  }
                }
              });
  
            });
          }
          
          
        });
  
        if($(form).find('.spr-form-label-required').length < 1){
          $(form).find('.spr-form-label').each((i, label) => {
            if(label.textContent.includes('*')) {
              return
            }

            $(label).append('<span class="spr-form-label__star"> *</span>');
          });
        }

        $(form).find('.spr-form-review-body').each((i, reviewBody) => {
          $(reviewBody).find('label span').removeAttr('role').removeAttr('aria-live').removeAttr('aria-atomic')
        });

      }
      
      const observer = new MutationObserver((mutations) => {
        for(const mutation of mutations) {
          if(mutation.target.classList.contains('spr-form-label')) {
            return
          }
        }

        handleChange();
      });

      handleChange();
  
      observer.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
  
    });
  }, 1000)

  $('#customer_login, #recover_email, #create_customer, form[action="/account/recover"]').each((i, form) => {
    $(form).find('#recover_email').each((i, recoverEmail) => {
      const label = $(recoverEmail).find('label');
      const input = $(recoverEmail).find('input[type="email"]');

      input.attr({
        'aria-label': label.text().trim(),
        'required': 'required',
        'aria-required': true,
        'id': label.attr('for')
      });
    });
    
    const inputs = $(form).find('[aria-required="true"]');
    const errors = $(form).find('.errors > ul');
    
    if(errors.length > 0) {
      errors.attr({
        'role': 'alert'
      })
    }

    inputs.each((i, input) => {
      const id = $(input).attr('id');
      const label = $(form).find(`label[for="${id}"]`);

      if(label.find('.form-label-required').length < 1) {
        label.append(`<span class="form-label-required"> *</span>`) 
      }
    });
  });

  $('form[action="/account/recover"]').each((i, form) => {
    const input = $(form).find('#recover_email input');
    const id = randomId();
    const note = $(form).find('em.note');

    if(note.length > 0) {
      note.attr({
        'id': id
      });
  
      input.attr({
        'aria-describedby': id
      });
    }
  });

  $('#login_form').each((i, form) => {
    const alert = $(form).find('> p > em');

    alert.attr({
      'role': 'alert'
    })
  })

  $('img[src*="631c735e-6a14-4c90-8259-19027071a160"').attr({
    'alt': 'LCD-5 Transparency, resolution and speed @ only 429g'
  });

  $('img[src*="11845753-abed-4cc3-a733-5cb9d4cbd7e6"').attr({
    'alt': 'MM Series by audeze'
  });

  $('img[src*="abb2db4b-4e1c-4b9c-925a-b5f74c4b18bc"').attr({
    'alt': 'Audeze LCD-GX Designed for serious gamers'
  });

  $('img[src*="dcc1aa60-3a41-4256-8303-9e0411f1c30d"').attr({
    'alt': 'Tech Tips, Reveal+ Logic'
  });

  $('img[src*="8401c398-7f5b-4b97-8fc2-87478f0ecc6a"').attr({
    'alt': 'Tech Tips, Reveal+ Reaper'
  });

  $('img[src*="d5abc5f7-f47c-41ad-8017-ea2fc4f87e8d"').attr({
    'alt': 'Tech Tips, Reveal+ Jriver'
  });

  $('img[src*="1e52bd33-594c-43bf-a0e5-293187f8270b"').attr({
    'alt': 'Quick Start Guide, Reveal+'
  });

  $('img[src*="41fe502f-3a2e-43bb-89c0-f30772e70ab8"').attr({
    'alt': 'Tech Tips, Soundsource'
  });

  $('img[src*="500e05cd-994a-4be8-966c-3a8f8b559704"').attr({
    'alt': 'Tech Tips, Ableton Live'
  });

  $('img[src*="7b74a80e-e3f1-4160-9609-0a4b71c6efbd"]').each((i, img) => {
    $(img).closest('h3').attr({
      'role': 'none'
    })
  });

  $('img[src*="Maxwell_Gallery_600x_3Q-PS_5000x.jpg"').each((i, img) => {
    $(img).attr('alt', 'Maxwell Wireless Gaming Headset designed for Playstation');
  });

  
  let clickedMyBtn = null;

  $('[id^="myBtn"]').each((i, button) => {
    $(button).attr({
      'role': 'button',
      'tabindex': 0
    });

    $(button).on('keydown', (e) => {
      if(e.key === 'Enter') {
        e.preventDefault();
        button.click();
      }
    });

    $(button).on('click', (e) => {
      clickedMyBtn = button
    });
  });

  $('#myModal').each((i, modal) => {
    const close = $(modal).find('.close');

    close.attr({
      'role': 'button',
      'tabindex': 0
    });

    close.on('keydown', (e) => {
      if(e.key === 'Enter') {
        e.preventDefault();
        close.click();
      }
    });
    
    close.on('click', (e) => {
      $(clickedMyBtn).focus();
    });

    const observer = new MutationObserver((mutations) => {
      if(modal.style.display === 'block') {
        $(modal).attr({
          'role': 'dialog',
          'aria-modal': true,
          'tabindex': -1
        })
        $(modal).parents().siblings().attr("aria-hidden", "true");
        $(modal).find(focusableSelector).first().focus();
        trapFocus(modal);
      } else {
        $(modal).parents().siblings().removeAttr("aria-hidden");
        $(modal).removeAttr('role').removeAttr('aria-modal').removeAttr('tabindex');
      }
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['style']
    });
    
  });



   setTimeout(function (){
     $('.shopify-payment-button__more-options').attr('role','link');
     $('#transcyBtnSwitcher').attr('aria-label','Language and currency');

      $('#transcyBtnSwitcher').keydown(function(event) {
        if(event.which == "13")
          $(this).click();
      });

     $('.form-control-storeify.pac-target-input').attr('aria-label','Search Our Store');
     $('#frm-storelocator-search #address').after('<strong>Search Our Store</strong>');
     $('.chose-search-slt.form-control-storeify').attr('aria-label','Dealer Location');
     $('#stores-country-filter select.storeifyapp_stores_countrys_filter_list').attr('aria-label','Country');
     $('#stores-tags-filter .storeifyapp_stores_tags_filter_list').attr({'role':'group', 'aria-label':'Filter By'});
     $('#stores-tags-filter .storeifyapp_stores_tags_filter_list > li').attr('role','none');
     $('button#submit-search').attr('aria-label','Search');

     $('.item-content .store-name').attr({'role':'heading','aria-level': 2});
     $('.spr-pagination span.spr-pagination-next').attr('role','listitem');

     $('.shg-sld-content .shg-sld-nav-button.shg-sld-left').attr({'role':'button','tabindex':'0','aria-label':'Previous'});
     $('.shg-sld-content .shg-sld-nav-button.shg-sld-right').attr({'role':'button','tabindex':'0','aria-label':'Next'});

     $('.shg-sld-content .shg-sld-nav-button.shg-sld-left, .shg-sld-content .shg-sld-nav-button.shg-sld-right').keydown(function (event){
       if(event.which == "13"){
         $(this).click();
       }
     });
   },2000) 

  setTimeout(function () {
    var page = $('html[data-page-url="/apps/product-registration"]');
    if(page.length > 0){
    $('head title').text('Audeze LLC - Product Registration');
    }
  },2000);

    $('.product-recommendations .product__details').each(function(){
      var infotext = $(this).find('.price-ui-badges .price-ui-badge__sticker').text().trim().replace(/\s\s+/g, ' '); 
      var imgtext = $(this).find('.product-info__caption .product-details').text().trim().replace(/\s\s+/g, ' ');
      $(this).find('.relative.product_image > a img').attr('alt',infotext +' '+imgtext);
    });


    $('#mpr-customer-form input.btn.btn-primary').click(function(event){
      setTimeout(function() {
        $('#mpr-customer-form input.form-control-danger').first().focus();

      },100);
      
    });

  
  $('form.vf-form-pristine').each(function (index, element) {
    const observer = new MutationObserver(function (mutations) {

      // $('.form-group.error p').each(function(){
      //   var errortext = $(this).text().trim(); 
      //   $(this).text(errortext+' '+'required');
      // });

      $('.form-group.error').attr('role','alert');


      
    });

    observer.observe(element,{
      childList: true,
      subtree: true
    })
  });

  $('#mpr-product-inputs input[name="serialNumber"]').parent().each(function (index, element) {
    const infoBtn = $("a[href*='/apps/product-registration?serialNumber=true']");
    infoBtn.attr('aria-label', 'Serial Number Locations');

    infoBtn.on('focus', (e) => {
      infoBtn.attr('aria-label', 'Serial Number Locations');
    });
    
    $(element).find('input').on('focus', (e) => {
      infoBtn.attr('aria-label', ' ');
    });

    $(element).find('input').on('blur', () => {
      infoBtn.attr('aria-label', 'Serial Number Locations');
    });

    const observer = new MutationObserver(function (mutations) {

      outer: for(const mutation of mutations) {
        inner: for(const node of mutation.addedNodes) {
          const clone = $(node).clone();
          clone.find('i').remove();
          announceToScreenReader(`serial number ${clone.text()} added`);

          const removeBtn = $(node).find('.remove-serial-number');
          removeBtn.attr({
            'tabindex': 0,
            'role': 'button',
            'aria-label': `remove serial number ${clone.text()}`
          });

          removeBtn.removeAttr('aria-hidden');
          
          removeBtn.on('click', () => {
            announceToScreenReader(`serial number ${clone.text()} removed`);
          });

          removeBtn.on('keydown', (e) => {
            if(e.key === 'Enter') {
              $(e.target).click()
            }
          })

          continue inner
          continue outer
        }
      }
    });
    
    observer.observe(element,{
      childList: true,
      subtree:true
    });
  });

  $('#frm-storelocator-search #reset-search').attr({'role':'button','tabindex':'0','aria-label':'Reset'});
  $('#frm-storelocator-search #reset-search').keydown(function(event) {
    if(event.which == "13")
      $(this).click();
  });

// Serach result announced in parts

  $('.map-tab-result').each(function (index, element) {

    function handleChange() {
      const title = element.querySelector('#results-slt h3, .store-name');

      if(title) {
        title.setAttribute('role', 'heading');
        title.setAttribute('aria-level', 2);
        title.setAttribute('aria-live', 'assertive');
      }

      const icon = element.querySelector('.item-content > .material-icons-outlined');

      if(icon) {
        icon.setAttribute('aria-hidden', true)
      }

      const items = element.querySelectorAll('.item-content');

      if(items.length > 0) {
        items.forEach((item, i) => {
          const label = item.querySelector('.store-name');

          if(!label) {
            return
          }
          
          const labeltext = label.textContent.trim();
          const detailStore = item.querySelector('a.linkdetailstore');
          const directionStore = item.querySelector('a.getdirectionstore');

          if(detailStore) {
            detailStore.setAttribute('aria-label', `${labeltext} view details`)
          }

          if(directionStore) {
            directionStore.setAttribute('aria-label', `${labeltext} directions`)
          }
        })
      }
    }
    
    const observer = new MutationObserver((mutations) => {
      handleChange();
    });

    handleChange();
    
    observer.observe(element,{
      childList: true,
      subtree:true
    });
  });

  $('.map-tab-mobile-bnt').each((i, tablist) => {
    $(tablist).attr('role','tablist');
    const buttons = $(tablist).find('.map-tab-mobile-bnt-item');

    buttons.each((i, button) => {
      const $button = $(button);
      
      $button.attr({
        'role':'tab',
        'aria-selected':'false',
      });

      $button.text(`${$button.text()}${i}`)

      function handleChange() {
        buttons.each((i, _button) => {
          _button.setAttribute('aria-selected', _button.classList.contains('active'));
  
          if(_button.classList.contains('active')) {
            _button.setAttribute('tabindex', 0);
            _button.focus();
          } else {
            _button.setAttribute('tabindex', -1) 
          }
        })
      }


      handleChange();

      button.addEventListener('click', (e) => {
        e.preventDefault();
        handleChange();
      })

      
    });
  });

  $('.has-sidebar-option.sidebar-enabled--false .product__details').each(function(){
      var infotext = $(this).find('.product-info__caption .product-details').text().trim().replace(/\s\s+/g, ' '); 
      // var imgtext = $(this).find('.product-info__caption .product-details').text().trim().replace(/\s\s+/g, ' ');
      $(this).find('.product_image .image-element__wrap img').attr('alt',infotext);
  });

  $('#myBtn.posterimage').each((i, button) => {
    button.setAttribute('id', `${button.getAttribute('id')}${i}`);
  });

  
  $('div[data-tooltip][title]').each((i, el) => {
    el.removeAttribute('title');
  });

  $('[data-page-url="/pages/audeze-cookie-policy"]').each((i, page) => {
    $(page).find('table').each((i, table) => {
      const firstRow = $(table).find('thead tr:first-child');
      const caption = firstRow.find('td:nth-child(2)');

      firstRow.attr({
        'aria-hidden': true
      })
      
      $(table).prepend(`<caption class="sr-only">${caption.text()}</caption>`);

      $(table).find('thead tr:nth-child(2) td').each((i, td) => {
        $(td).attr({
          'role': 'columnheader',
          'scope': 'col'
        });
      });

      firstRow.attr({
        'role': 'none'
      })
      
    })
  });


  $('.product-gallery__image').each((i, galleryImage) => {
    const zoomImg = $(galleryImage).siblings('.zoomImg');

    if(zoomImg.length < 1) {
      return
    }


    zoomImg.attr({
      'aria-hidden': true
    });

    function handleLightbox() {
      const lightbox = $('.product-section__lightbox');

      console.log(lightbox, 'test');
    }


    galleryImage.addEventListener('click', (e) => {
  
    });

  });

  $('.product_name').each((i, el) => {
    const productName = $(el);
    let productNameText = productName.text();

    productNameText = productNameText.replace(/(\d\/\d+)"/g, '$1<span class="sr-only"> inches</span><span aria-hidden="true">&#34;</span>');
    
    productName.html(productNameText);
  });
  

  $('a[href="#FAQs"]').each((i, anchor) => {
    anchor.setAttribute('aria-label', anchor.textContent.toLowerCase());
  })

  const shopifyProductForm = document.querySelector(".shopify-product-form");
/*
  isElementVisible(".affirm-modal-trigger", shopifyProductForm).then((trigger) => {
    trigger.attr({
      'role': 'button'
    });
  });
*/
  $('.product .shogun-table').each((i, table) => {
    const title = $(table).find('thead tr:first-child td:first-child');
    const name = $('h1.product_name');
    const caption = $(`<caption class="sr-only">${name.text().trim()} ${title.text().trim()}</caption>`);

    if($(table).closest('.comparison-chart').length < 1) {
      $(table).attr({
        'role': 'none'
      });
      $(table).find('thead').attr({
        'role': 'none'
      });      
  
      $(table).find('tbody').attr({
        'role': 'none'
      });
  
      $(table).find('tbody tr').attr({
        'role': 'none'
      });
  
      title.attr({
        'role': 'heading',
        'aria-level': 3
      }); 
    } else {
      $(table).prepend(caption);

      $(table).attr({
        'role': 'table'
      });
  
      $(table).find('thead, tbody, tfoot, tr, th, td').attr('role', function() {
        if ($(this).is('table')) {
          return 'table';
        } else if ($(this).is('thead')) {
          return 'rowgroup';
        } else if ($(this).is('tbody')) {
          return 'rowgroup';
        } else if ($(this).is('tfoot')) {
          return 'rowgroup';
        } else if ($(this).is('tr')) {
          return 'row';
        } else if ($(this).is('th')) {
          return 'columnheader';
        } else if ($(this).is('td')) {
          return 'cell';
        }
      });
    }

  });

  $('.comparison-chart').each((i, chart) => {
    const table = $(chart).find('table');
    const checks = table.find('p > span:contains("✔")');
    const unchecks = table.find('p > span:contains("✖")');

    checks.each((i, check) => {
      $(check).append('<span class="sr-only">Included</span>');
    });

    unchecks.each((i, uncheck) => {
      $(uncheck).append('<span class="sr-only">Not Included</span>');
    });

    table.find('thead tr td').attr({
      'scope': 'col'
    });

    table.find('tbody tr').each((i, th) => {
      $(th).find('td').first().attr({
        'scope': 'row'
      });
    });
  });

  $('.section__mini-add-to-cart').each((i, cart) => {
    $(cart).find('ul').each((i, ul) => {
      if(ul.textContent.trim() === "") {
        $(ul).attr({
          'aria-hidden': true
        });
      };
    });

    $(cart).find('.shg-product-title-component h1').attr({
      'role': 'heading',
      'aria-level': 2
    })
  });

  $('img[data-shg-lightbox-image]').each((i, img) => {
    const wrapper = $(img).closest('.shg-product');
    
    wrapper.attr({
      'tabindex': 0,
      'role': 'button'
    });

    wrapper.on('keydown', (e) => {
      if(e.key === 'Enter') {
        img.click();
      }
    });

    wrapper.on('click', (e) => {
      img.click();
    });

    $(img).on('click', (e) => {
      const lightbox = $('.shg-lightbox');
      const close = lightbox.find('.shg-lightbox-close'); 
      
      close.attr({
        'tabindex': 0,
        'role': 'button'
      });

      lightbox.on('keydown', (e) => {
        if(e.key === 'Enter') {
          close.click();
        }
      });

      lightbox.on('click', (e) => {
        const lightboxImage = lightbox.find('img.shg-lightbox-image');
        $(`img[data-shg-lightbox-image][data-src="${lightboxImage.attr('src')}"]`).closest('.shg-product').focus();
      });
      
      const observer = new MutationObserver((mutations) => {
        if(!lightbox.hasClass('hidden')) {
          lightbox.attr({
            'role': 'dialog',
            'aria-modal': true,
            'tabindex': -1
          });
          lightbox.parents().siblings().attr("aria-hidden", "true");
          lightbox.find(focusableSelector).first().focus();
          
          trapFocus(lightbox);
        } else {
          lightbox.parents().siblings().removeAttr("aria-hidden");
          lightbox.removeAttr('role').removeAttr('aria-modal').removeAttr('tabindex');
        }
      });

      observer.observe(lightbox.get(0), {
        attributes: true,
        attributeFilter: ['class']
      });
      
    })
    
  });


  $('.shg-product').each((i, el) => {
    const title = $(el).find('.shg-product-title-component');
    const button = $(el).find('.shg-btn');
    const imageLink = $(el).find('[data-shg-product-target="product-url"]');

    button.attr({
      'aria-label': `${button.text().trim()} about ${title.text().trim()}`
    });

    imageLink.attr({
      'aria-label': `${title.text().trim()}`
    });   
  });

  $('.shg-btn:not([href])').each((i, button) => {
    $(button).attr({
      'tabindex': 0,
    });
  });

  $(".a11_rem_role").removeAttr("role");
  $(".a11_rem_role").removeAttr("tabindex");
  $(".top-bar--right-menu .weglot-container").wrapAll(`<li role="listitem"></li>`);

  $('.flickity-button svg').attr('aria-hidden','true');

  $('.carousel__next > svg').attr('aria-hidden','true');

  $('.yotpo-score-filter > .yotpo-dropdown-base > .yotpo-dropdown-arrow-icon').attr('aria-hidden','true');
  $('.yotpo-radio-icon').attr('aria-hidden','true');
  $('.yotpo-custom-questions-filter > .yotpo-radio-base > .yotpo-dropdown-closable > .yotpo-dropdown-base > .yotpo-dropdown-arrow-icon').attr('aria-hidden','true');
  $('.yotpo-filters-right-panel > .yotpo-radio-base > .yotpo-dropdown-closable > .yotpo-dropdown-arrow-icon').attr('aria-hidden','true');
  $('div.yotpo-review-card > .card-container > .content-container-with-votes > .yotpo-reviewer > .yotpo-reviewer-badge-container > div > .yotpo-verified-icon').attr('aria-hidden','true');
  $('.is-product-main .shg-rich-text.shg-theme-text-content li').removeAttr('aria-level');

  $('.yotpo-base-layout').each(function () {
  const $this = $(this);
  const labelBy = $this
    .find('.yotpo-bold-layout.yotpo-main-reviews-widget')
    .attr('aria-labelledby');
  const $headline = $this.find('.yotpo-headline');
  if (labelBy && $headline.length) {
    $headline.each(function () {
      if (!$(this).attr('id')) {
        $(this).attr('id', labelBy);
      }
    });
  }
  $headline.attr({'role':'heading','aria-level':'2'});
});

  $('div.shg-c-lg-2_4 > .shg-box-vertical-align-wrapper > .shg-box > .shg-box-content > .shg-c.shogun-image-container > img[src*="/auto/-/preview/3000x3000/-/quality/lighter/"]').attr('alt',"");

  $('.shopify-product-form').each(function(){
    $('select.single-option-selector').each((i, select) => {
      const labelid = $(select).attr('id'); 
      const existingLabel = $(`label[for="${labelid}"]`);
      if(existingLabel.length < 1) {
        $(select).before(`<label for="${labelid}">Select Product Variant</label>`);  
      }
    })
  });
  

  $(".yotpo-score-filter #scoreDropdownInput").attr({
    role: "combobox",
    "aria-label": "Filter By Rating"
  });

  // Remove height and width from img
  $('.shogun-image').each(function () {
  const $this = $(this);

  if ($this.attr('width') === "") {
    $this.removeAttr('width');
  }

  if ($this.attr('height') === "") {
    $this.removeAttr('height');
  }
});


$('[data-page-url="/products/lcd-mx4"] .shg-rich-text.shg-theme-text-content h3').attr({'role':'heading','aria-level':'2'});
$('[data-page-url="/collections/pro-audio/products/mm-500"] .shg-rich-text.shg-theme-text-content h3').attr({'role':'heading','aria-level':'2'});
$('[data-page-url="/products/mm-500"] .shg-rich-text.shg-theme-text-content h3').attr({'role':'heading','aria-level':'2'});
$('[data-page-url="/collections/pro-audio/products/mm-100"] .shg-rich-text.shg-theme-text-content h3').attr({'role':'heading','aria-level':'2'});
$('[data-page-url="/products/mm-100"] .shg-rich-text.shg-theme-text-content h3').attr({'role':'heading','aria-level':'2'});
$('[data-page-url="/collections/pro-audio/products/lcd-xc"] .shg-rich-text.shg-theme-text-content h3').attr({'role':'heading','aria-level':'2'});
$('[data-page-url="/collections/pro-audio/products/lcd-xc"] #s-de90f7b8-5a06-4266-85ac-b28dcbd41393 .shg-rich-text.shg-theme-text-content h6').attr({'role':'heading','aria-level':'2'});
$('[data-page-url="/products/maxwell-2-wireless-gaming-headset"] img[src*="/s/files/1/3013/1908/files/SwipeIcon2.svg"]').attr('alt',"");
$('[data-page-url="/products/maxwell-2-wireless-gaming-headset"] .product-viewer-360__image-container img').attr('alt',"");
$('[data-page-url="/products/maxwell-2-wireless-gaming-headset"] .product-viewer-360__image-container img').removeAttr('role');
$('.shg-sld-nav-button svg').attr('aria-hidden','true');

$('.shg-image-content-wrapper > img[src*="/-/format/auto/-/quality/normal/"]').each(function(){
  const $this = $(this);

  if(!$this.attr('alt')){
    $this.attr('alt','Close-up of Maxwell 2 headphone headband');
  }
});


  $('.yotpo-score-filter').removeAttr('role aria-expanded aria-controls');

function removeAriaExpanded(){
 const target = document.querySelector('.yotpo-score-filter-container');
  
   if (!target) return;

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes" && mutation.attributeName === "aria-expanded") {
        $(target).removeAttr('aria-expanded');
      }
    });
  });

  observer.observe(target, {
    attributes: true
  });
}

removeAriaExpanded();
 
$('[data-page-url="/collections/accessories/products/1-4-to-1-8-stereo-adapter"] .shogun-heading-component h3').attr({'role':'heading','aria-level':'2'});

setInterval(function(){
  $('input.yotpo-filter-select').removeAttr("aria-haspopup");
  $(".yotpo-main-reviews-widget").removeAttr("aria-labelledby").removeAttr("role");

  $(".flickity-slider .gallery-cell").each(function(){
    const $anchor = $(this).find("a.lightbox");
    $anchor.removeAttr("tabindex");
  });

}, 1000);

$('.shg-box .shg-c-lg-2 .shg-box-content img').attr("alt", "");

$(".shogun-accordion-wrapper h4.shogun-accordion-title").attr({
  role: "heading",
  "aria-level": "2"
});

$('.shogun-accordion-body ul li[role="presentation"]').removeAttr("role");

// Code to remove alts from Shogun images
$('#s-fc47d61f-4c2f-4cd5-94d3-4032e8623eca img.shogun-image ').attr("alt", "");

$("#s-e635367f-a803-4c4a-9b45-cf6bc2e7f51c table").attr("role", "none");

$("#s-19f17aef-9cb2-4de2-8223-fd7b32f10beb h4, #s-1c4d8cab-4471-4fe2-bfe6-c0e826d06e5d h5, #s-b59ac7a4-f240-4ed5-ac09-fbd8281fc842 h3, #s-fd8e5de8-6d53-4f85-b799-95d6b3831ac5 h6, #s-b21f09f2-1553-4526-a46f-2640f7095bb0 h4, #s-40453285-7217-4e9f-89f0-119752a135df h3, .product-block--description h3, #s-c1ae4b18-13a2-45ad-995d-454bb94d88ee h5, #s-0973338e-bcf3-4498-8729-ce502e7c8f78 h4").attr({
  role: "heading",
  "aria-level": "2"
});

$("a.rca-add-to-cart-submit").attr("role", "button");

$("div#s-870f13b5-afc7-4eb9-b725-98d7b596d1c2, div#s-45877991-c4bd-4d40-82ed-1f14b49d748b, div#s-dbdd97a5-ff8c-4977-a691-d5319fe38caf, div#s-2e865c49-69b0-475e-8034-ade210077724").removeAttr("role").removeAttr("tabindex");

$('.a11y-getHref').each(function () {
  const $this = $(this);
  const hrefVal = $this.attr('data-href');

  if (hrefVal) {
    $this.attr('href', hrefVal);
  }
});

$('[data-nav-desktop-details]').each(function () {
  const $details = $(this);
  const $target = $details.find('[data-animation-state]').first();

  // Focus enters
  $details.on('focusin', function () {
    $target.attr('data-animation-state', 'open');
    $details.prop('open', true);
  });

  // Focus leaves
  $details.on('focusout', function () {
    setTimeout(() => {
      if (!$details[0].contains(document.activeElement)) {
        $target.attr('data-animation-state', 'closed');
        $details.prop('open', false);
      }
    }, 0);
  });

});

$(document).on('keydown', function (e) {
  if (e.key === 'Escape') {

    $('[data-nav-desktop-details][open]').each(function () {
      const $details = $(this);
      const $target = $details.find('[data-animation-state]').first();

      $details.prop('open', false);
      $details.blur();
      $target.attr('data-animation-state', 'closed');
    });

  }
});


$('.nav-desktop__tier-1-item').each(function () {
  const $li = $(this);

  const linkText = $li.find('> a').first().text().trim();
  const $summary = $li.find('summary').first();

  if (linkText && $summary.length) {
    $summary.attr('aria-label', linkText);
  }
});

  console.log("load!");
});


function trapFocus(element) {
  const $ = jQuery;

  const focusableElements = $(element).find(focusableSelector);

  focusableElements.first().focus();

  focusableElements.last().on("keydown", (e) => {
    if (e.originalEvent.code === "Tab" && !e.originalEvent.shiftKey) {
      e.preventDefault();
      focusableElements.first().focus();
    }
  });

  focusableElements.first().on("keydown", (e) => {
    if (e.originalEvent.code === "Tab" && e.originalEvent.shiftKey) {
      e.preventDefault();
      focusableElements.last().focus();
    }
  });
}


function isElementVisible(selector, wrapper = document.body) {
  const $ = jQuery;

  return new Promise((resolve, reject) => {
    try {
      if (!wrapper || !selector) {
        return reject();
      }

      if ($(selector).length > 0) {
        return resolve($(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if ($(selector).length > 0) {
          resolve($(selector));
          observer.disconnect();
        }
      });

      observer.observe(wrapper, {
        childList: true,
        subtree: true,
      });
    } catch (error) {
      return reject();
    }
  });
}

function announceToScreenReader(text, role, timeout = 1000) {
  const liveElement = document.querySelector(".live-status-region");
  const paraElement = document.createElement("p");
  const textElement = document.createTextNode(text);

  if (!liveElement) {
    return;
  }

  liveElement.setAttribute("role", role === undefined ? "status" : role);
  paraElement.appendChild(textElement);
  liveElement.appendChild(paraElement);

  setTimeout(() => {
    liveElement.innerHTML = "";
    liveElement.setAttribute("role", "status");
  }, timeout);
}


function randomId(length = 10) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}
  
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}
